import { Injectable, inject } from '@angular/core';
import { ApplicationGroupService, ApplicationService, AuthorizedOperationService, UsernameGroupService, UsernameService } from '@api/sts-application/index';
import { ScopeService } from '@api/sts/index';
import { WebApplicationConfigurationService } from '@app/shared/services/web-application-configuration.service';
import { ReplaySubject, forkJoin } from 'rxjs';
import { take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ExternalApiModuleWrapper {
  // Services
  private webApplicationConfigurationService = inject(WebApplicationConfigurationService);
  private usernameService = inject(UsernameService);
  private applicationService = inject(ApplicationService);
  private usernameGroupService = inject(UsernameGroupService);
  private applicationGroupService = inject(ApplicationGroupService);
  private authorizedOperationService = inject(AuthorizedOperationService);
  private scopeService = inject(ScopeService);

  // Properties
  public isStsInitialized = new ReplaySubject<boolean>();
  public isStsApplicationInitialized = new ReplaySubject<boolean>();

  constructor() {
    forkJoin([this.webApplicationConfigurationService.getPublicPropertyValue('public.authorization-config.baseUrl', undefined)]).subscribe(([stsBaseUrl]) => {
      this.scopeService.configuration.basePath = stsBaseUrl ? stsBaseUrl : undefined;
      this.isStsInitialized.next(true);
    });
  }

  public waitStsInitialized(): Promise<void> {
    return new Promise<void>((resolve) => {
      this.isStsInitialized.pipe(take(1)).subscribe((_val) => resolve());
    });
  }

  public waitStsApplicationInitialized(): Promise<void> {
    return new Promise<void>((resolve) => {
      this.isStsApplicationInitialized.pipe(take(1)).subscribe((_val) => resolve());

      this.webApplicationConfigurationService.getPublicPropertyValue('public.sts-application.authorization-config.baseUrl', undefined).subscribe((baseUrl) => {
        this.usernameService.configuration.basePath = baseUrl ? baseUrl : undefined;
        this.usernameGroupService.configuration.basePath = baseUrl ? baseUrl : undefined;
        this.applicationGroupService.configuration.basePath = baseUrl ? baseUrl : undefined;
        this.authorizedOperationService.configuration.basePath = baseUrl ? baseUrl : undefined;
        this.isStsApplicationInitialized.next(true);
      });
    });
  }

  public stsScopeService(): ScopeService {
    return this.scopeService;
  }

  public stsApplicationUsernameService(): UsernameService {
    return this.usernameService;
  }

  public stsApplicationApplicationService(): ApplicationService {
    return this.applicationService;
  }

  public stsApplicationUsernameGroupService(): UsernameGroupService {
    return this.usernameGroupService;
  }

  public stsApplicationApplicationGroupService(): ApplicationGroupService {
    return this.applicationGroupService;
  }

  public stsApplicationAuthorizedOperationService(): AuthorizedOperationService {
    return this.authorizedOperationService;
  }
}
